import React, { useEffect, useState } from "react";
import ServiceCard from "./ServiceCard";

const Services = () => {
  const [services, setServices] = useState([]);
  useEffect(() => {
    fetch("services.json")
      .then((res) => res.json())
      .then((data) => setServices(data));
  });
  return (
    <section>
      <div className="text-center">
        <p className="text-2xl font-bold text-blue-500">Services</p>
        <h2 className="lg:text-5xl md:text-4xl max-sm:text-3xl font-semibold pt-5">
          Our Service Area
        </h2>
        <p className="text-lg max-sm:text-sm pt-5 font-semibold">
        Explore a world of custom suits, shirts, pants, panjabis, trousers, and more that are as unique as you are.
          <br />
          we've been your trusted source for premium attire for 31 years and counting.
        </p>
      </div>
      <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 my-5 pt-5">
        {services.map((service) => (
          <ServiceCard key={service._id} service={service} />
        ))}
      </div>
    </section>
  );
};

export default Services;
